module.exports = __webpack_public_path__ + "img/minus_light.811f2b1d.svg";